import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Space, Table, Form, Input , Button, Popconfirm, message, Select, InputNumber, Row, Col } from 'antd';
import { DatePicker, CrmSelectBox, CompanySelectBox } from 'components/atoms'
import { useBillRequestDetail, useRefCode } from 'hooks';
import { TableWrapper } from 'components/molecules';
import { ColumnsType } from 'antd/lib/table/interface';
import moment, { Moment } from 'moment';
import { dateFormat } from 'utils/date-utils';
import { IMaskInput } from "react-imask";

export interface BillB2BRequestModalModalProps extends PopupProps {
    id: number;
}

const BillB2BRequestModal = ({ isOpen, onClose, id }: BillB2BRequestModalModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
  const [companySrl, setCompanySrl] = useState<number>(0);
  const [companyName, setCompanyName] = useState<string>('');
  const [companyPoint, setCompanyPoint] = useState<number>(0);
  const [companyMoney, setCompanyMoney] = useState<number>(0);
  const [requestList, setRequestList] = useState<BillItemInfoDto[]>([]);
  const [drawList, setDrawList] = useState<BillItemInfoDto[]>([]);
  const [selected, setSelected] = useState<BillItemInfoDto[]>([]);
  const [billPrice, setBillPrice] = useState<number>(0);

   /* ======================================================
   * variables
   * ====================================================== */
   const [form] = Form.useForm();
   const { TextArea } = Input;

   const configBlocks = {
    PriceInput: {
      mask: Number,
      signed: true,  // disallow negative
      thousandsSeparator: ",",  // any single char
      padFractionalZeros: false,
      normalizeZeros: false,
    }
  }

   const columns: ColumnsType<BillItemInfoDto> = [
    {
      title: '교육일',
      dataIndex: 'start_day',
      key: 'start_day',
      width: '200px',
      align: 'center',
      ellipsis: true,
    },
    {
     title: '교육장소',
     dataIndex: 'lecture_place',
     key: 'lecture_place',
     width: 'auto',
     align: 'center',
     ellipsis: true,
   },   
   {
     title: '강의구분',
     dataIndex: 'lecture_type',
     key: 'lecture_type',
     width: 'auto',
     align: 'center',
     ellipsis: true,
   },   
   {
     title: '매출',
     dataIndex: 'max_price',
     key: 'max_price',
     width: '100px',
     align: 'right',
     ellipsis: true,
     render: (max_price, record) => {
      return (
        max_price && max_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      )
    }     
   }, 
   {
    title: '미발행매출',
    dataIndex: 'no_bill_price',
    key: 'no_bill_price',
    width: '100px',
    align: 'right',
    ellipsis: true,
    render: (no_bill_price, record) => {
      return (
        no_bill_price && no_bill_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      )
    }      
  },  
  {
    title: '발행금액',
    dataIndex: 'bill_pirce',
    key: 'bill_pirce',
    width: '120px',
    align: 'right',
    ellipsis: true,
    render: (bill_pirce, record, index) => {
      const select = selected.find((item) => item.key === record.key);
      return (
        (select && bill_pirce)?(
          <IMaskInput 
            min={0} 
            max={record.no_bill_price} 
            mask = {Number}
            thousandsSeparator={','}
            defaultValue={record.no_bill_price}
            className={'ant-input'} 
            unmask={'typed'} 
            onAccept = {((value, mask) => onInputChange("bill_pirce", record.orgindex, value))}/>                
        ):(
          bill_pirce && bill_pirce.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        )
      )
      }
  },      
  ];
   /* ======================================================
   * events
   * ====================================================== */
   
  const onCloseCancle = () => {
    onClose?.(false); 
  }  

  const onInsert = () => {
    let items = ''
    selected.forEach((select) => {
      const find = requestList.find((item) => item.key === select.key && item.bill_pirce && item.bill_pirce > 0);
      if (!!find) {
        if (items.length > 0) items += ',';
        items += find.key + '_' + find.bill_pirce;
      }
    });

    if (form.getFieldValue("bill_type") === 'point' && companyPoint < (billPrice*1.1)) {
      message.error('포인트가 부족합니다.', 1);
    } else if (form.getFieldValue("bill_type") === 'prepay' && companyMoney < billPrice) {
      message.error('선납금이 부족합니다.', 1);
    } else if (items.length > 0) {
      const data = {
        id: 0,
        bill_group: 'b2b',
        bill_type: form.getFieldValue("bill_type"),
        bill_day: form.getFieldValue("bill_day") ? dateFormat(form.getFieldValue("bill_day"), 'YYYY-MM-DD'):'null',
        group_srl: id,
        group_name: billInfo?.group_name,
        public_company: 'Y',
        company_srl: form.getFieldValue("company_srl"),
        crm_srl: form.getFieldValue("crm_srl"),
        bill_price: billPrice,
        title: form.getFieldValue("title"),
        memo: form.getFieldValue("memo"),
        items: items,
      }

      billInsert(data) 
    }

  }
  const onInputChange = (key, index, value) => {
    const newData = [...requestList];
    setBillPrice(billPrice + (Number(value) - newData[index][key])); 
    newData[index][key] = Number(value);
    setRequestList(newData);
  };

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: BillItemInfoDto[]) => {

      let price = 0;
      requestList.forEach((item) => {
        const find = selectedRows.find((select) => item.key === select.key)
        if (!!find) {
          if (item.bill_pirce === 0) item.bill_pirce = find.bill_pirce;
          price += item.bill_pirce || 0;
        } else {
          item.bill_pirce = 0;
        }        
      });

      setBillPrice(price);
      setSelected(selectedRows);
      

    },

    getCheckboxProps: (record: BillItemInfoDto) => ({
      disabled: (record.key.startsWith('N') && (0 === record.bill_pirce || record.start_day === '미정')),
    }),
  };
  /* ======================================================
   * hooks
   * ====================================================== */
  const { billInfo, billItems, insertSuccess, billInsert } = useBillRequestDetail(id); 
  const { refCodeList: billType } = useRefCode({field:'bill_type', status_type: 'AV'});   

  /* ======================================================
   * effects
   * ====================================================== */

  useEffect(() => {
    if (!!billInfo) {
      form.setFieldsValue({
          bill_type: billInfo.bill_type,
          bill_day: (!!billInfo.bill_day && billInfo.bill_day !== '0000-00-00') ? moment(billInfo.bill_day, "YYYY-MM-DD") : undefined,
          crm_srl: billInfo.crm_srl,
          company_srl: billInfo.company_srl, 
          memo: billInfo.memo,
          title: billInfo.title,
      });
      setCompanySrl(billInfo.company_srl);
      setCompanyName(billInfo.company_name);      
    }     
  }, [billInfo])

  useEffect(() => {
    if (!!billItems) {
      const datas: BillItemInfoDto[] = [];
      let month = '';
      
      billItems.forEach((item, index) => {
        if (item.key.startsWith('N')) {
          if (item.start_month !== month) {
            month = item.start_month;
          
            let cnt = 0;
            let maxprice = 0;
            let nobillprice = 0;
            billItems.forEach((item1) => {
              if (item1.key.startsWith('N') && item1.start_month === month) {
                cnt ++;
                if (item1.max_price) maxprice += item1.max_price;
                if (item1.no_bill_price) nobillprice += item1.no_bill_price;
              }
            });

            datas.push({
              id: 0,
              orgindex: -1,
              key: 'M' + item.start_month,
              group_srl: 0,
              start_month: '',
              start_day: item.start_month + ' ' + cnt.toString() + '건',
              end_day: '',
              lecture_place: '',
              lecture_type: '',
              max_price: maxprice, 
              no_bill_price: nobillprice, 
              bill_pirce: undefined,  

              children: [],              
            });
          }
          
          datas[datas.length-1].children?.push({...item, orgindex:index});          
          
          
        } else {
          datas.push({...item, orgindex:index});
        }
      })
      setDrawList(datas);     
      setRequestList(billItems);     
    }     
  }, [billItems])

  useEffect(() => {
    if (insertSuccess)
    onClose?.(true);     
  }, [insertSuccess])  

    return (
        <ModalWrapper open={isOpen} onCancel={onCloseCancle} width={850} title={'계산서 발행 요청서'} closable>
            <Space direction="vertical" style={{ width: '100%' }}>
            <Form
                    form={form}
                    name="RefCode"
                    layout="horizontal"  
                    labelCol={{ flex: '100px' }}
                    style={{width:'100%', marginBottom:'20px'}}
                >
                    <Form.Item label={'고객사'}>
                      <CompanySelectBox required={false} form={form} company_srl={companySrl} onSelected={(value, option) => {setCompanySrl(Number(value)); setCompanyName(option.label); setCompanyMoney(option.money); setCompanyPoint(option.point)}} view_info/>
                    </Form.Item>   
                    <Form.Item label={'결제담당자'}>
                      <CrmSelectBox form={form} company={companySrl} company_name={companyName} view_info/>  
                    </Form.Item>     
                    <Row>
                      <Col span={12}>
                        <Form.Item label={'프로젝트명'}>
                            <label>{billInfo?.group_name}</label>                  
                        </Form.Item>   
                      </Col>
                      <Col span={12}>
                        <Form.Item label={'기간'}>
                            <label>{billInfo?.group_date}</label>                  
                        </Form.Item>                           
                      </Col>
                    </Row>   
                    <Form.Item name="bill_type" label={'발행구분'}>
                      <Select placeholder="발행형태 선택" style={{width:"150px"}}>
                      {billType?.map((item) => {
                          return (<Select.Option key={item.name} value={item.name}>{item.value}</Select.Option>)
                      })}                        
                      </Select>  
                    </Form.Item>                           
                    <Row>
                      <Col span={12}>
                        <Form.Item name="bill_day" label={'발행일'}>
                          <DatePicker showTime={false} format="YYYY-MM-DD" />      
                        </Form.Item>    
                      </Col>
                      <Col span={12}>
                        <Form.Item name='title' label={'과정명'}>
                            <Input placeholder='과정명을 입력하세요'/>   
                        </Form.Item>                            
                      </Col>
                    </Row>                                                       
                    <Form.Item name='memo' label={'메모'}>
                        <TextArea rows={2} placeholder='메모를 입력하세요'/>   
                    </Form.Item>                                                             
                </Form> 

                <TableWrapper isSearch={false}>
                    <Table
                        tableLayout="fixed"
                        dataSource={drawList}
                        pagination={false}
                        columns={columns}
                        style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
                        showSorterTooltip={false}
                        scroll={{ y: 240 }}
                        rowKey={'key'}
                        rowSelection={{
                          ...rowSelection, checkStrictly:false
                        }}
                    />
                </TableWrapper>
                <div style={{float:"right"}}>
                  <label>발행금액: {billPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}원 (vat 포함: {(billPrice*1.1).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")})</label>
                </div>

              <ButtonGroup className={'buttonsWrapper'}>
                <Button onClick={()=>{onClose?.(false)}}>취소</Button>
                <Button onClick={onInsert} disabled={selected.length === 0 || billPrice === 0}>신청</Button>
              </ButtonGroup>  

            </Space>     
        </ModalWrapper>  
    )    
};

export default React.memo(BillB2BRequestModal);    